import { render, staticRenderFns } from "./VacantProperties.vue?vue&type=template&id=671c5828&"
import script from "./VacantProperties.vue?vue&type=script&lang=js&"
export * from "./VacantProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports